// import { Link } from "react-router-dom";
import DevtoLogo from "../assets/devto-article1.jpg"

function Blog() {
    return (
        <div className="blog container__blog general-margin_top">
            <h2 className="mb-3">JavaScript Math Object</h2>
            <a className="me-3" href="https://dev.to/mr_abbos/javascript-math-object-6o4" target="_blank" rel="noopener noreferrer">
                <img className="devtoLogo" src={DevtoLogo} alt="DevtoLogo" width={630} height={350} />
            </a>

            {/* <Link className="btn btn-outline-info back-btn" to="/"> ← Back </Link> */}
        </div>
    );
}

export default Blog;
